import { render, staticRenderFns } from "./Spectrum.vue?vue&type=template&id=1e3cddf6&scoped=true&"
import script from "./Spectrum.vue?vue&type=script&lang=js&"
export * from "./Spectrum.vue?vue&type=script&lang=js&"
import style0 from "./Spectrum.vue?vue&type=style&index=0&id=1e3cddf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3cddf6",
  null
  
)

export default component.exports